import { useMutation } from '@tanstack/react-query';
import { supportApi } from 'API/offline-reports-api';
import { SubmitRequestFlowPayload } from 'API/offline-reports-api/types';
import { resolverBridgeQueryKeys } from 'features/my-zone/support-requests/components/support-requests-modals/queries/resolver-queries-keys';

export const useSubmitRequestFlowMutation = () => {
    return useMutation({
        mutationKey: resolverBridgeQueryKeys.submitRequestFlow,
        mutationFn: async (payload: SubmitRequestFlowPayload) => {
            return supportApi.submitRequestFlow(payload);
        },
    });
};
